module.exports = __webpack_public_path__ + "ec3c752976fe997a1e364891ff603746.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/acne/acne-ingrown-hair-1b.jpg
 ** module id = 430
 ** module chunks = 0
 **/